/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import TutorialComponents from 'components/Tutorial/tutorial.components';

const VideoTutorial = () => {
   return (
      <Fragment>
         <Helmet>
            <title>วีดีโอสอนการใช้งาน</title>
         </Helmet>
            <TutorialComponents/>
      </Fragment>
   );
};

export default VideoTutorial;
